/** Chatur's WhatsApp number, without the '+'. Unset in environments that haven't been given one. */
export const CHATUR_WA_NUMBER = import.meta.env.VITE_CHATUR_WA_NUMBER as string | undefined;

/** Opens the Chatur chat on WhatsApp, optionally with a pre-filled message. Returns false when no number is configured. */
export const openChaturChat = (message?: string): boolean => {
  if (!CHATUR_WA_NUMBER) return false;
  const text = message ? `?text=${encodeURIComponent(message)}` : "";
  window.open(`https://wa.me/${CHATUR_WA_NUMBER}${text}`, "_blank", "noopener,noreferrer");
  return true;
};
